<template>
  <div>
    <section class="section">
      <div class="container">
        <h2 class="subtitle is-4 has-text-centered">When You Ate</h2>
        <p class="has-text-centered">1=starving 10=stuffed</p>
        <div class="columns is-centered">
          <div class="column is-half chartcolumn">
            <h2 class="subtitle has-text-centered">Your Hunger Before</h2>
            
            <div class="chart-container">
              <chartist ratio="ct-square" type="Pie"  :data="hungerBeforeChartData"></chartist>
              
            </div>
     
          </div>
          <div class="column is-half chartcolumn">
            <h2 class="subtitle has-text-centered">Your Hunger After</h2>
            <div class="chart-container">
              <chartist ratio="ct-square" type="Pie" :data="hungerAfterChartData"></chartist>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="section">
      <div class="container">
        <h2 class="subtitle is-5 has-text-centered">Your Meals</h2>
        <div class="columns is-centered">
          <div class="column is-half">
            <div v-bind:class="{'is-active': isLoading}" class="loader-wrapper">
                <div class="loader is-loading"></div>
            </div>
            <div v-if="!isLoading && meals.length ==0" class="has-text-centered">
              No meals found.
            </div>
            <div v-for="(meal,index) in meals" v-bind:key="index" class="box">
              <nav class="level is-mobile">
                <div class="level-left">
                  <div class="level-item">
                    <strong>{{meal.eatingTime.toLocaleString()}}</strong>
                  </div>
                </div>

                <!-- Right side -->
                <div class="level-right">
                  <p class="level-item">b:<strong>{{meal.hungerBefore}}</strong>/a:<strong>{{meal.hungerAfter}}</strong></p>
                </div>
              </nav>
              <p>
                {{meal.whatyouate}}
              </p>
              <p class="has-text-right">
                <router-link :to="'/meal/' + meal.id" class="button is-small ">Edit</router-link>
               
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
// @ is an alias to /src

import db from "../db";

export default {
  name: "Dashboard",
  components: {
    
  },
  data: function () {
    return {
      meals: [],
      isLoading: false,
      hungerBeforeChartData: null,
      hungerAfterChartData: null
    };
  },
  mounted: function () {
    this.loadMeals();
  },
  methods: {
    loadMeals: async function () {
      this.isLoading = true;
      this.meals = await db.getMealsDesc();
      console.log("loading", this.meals)
      this.isLoading = false;
      let hungersBefore = [0,0,0,0,0,0,0,0,0,0]
      let hungersAfter = [0,0,0,0,0,0,0,0,0,0]
      for(var i=0; i< this.meals.length;i++) {
        let hungerBefore = this.meals[i].hungerBefore
        hungersBefore[hungerBefore -1]++

        let hungerAfter = this.meals[i].hungerAfter
        hungersAfter[hungerAfter -1]++
        
      }
      const labels = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10"]
      console.log("hungersum", hungersBefore )
      this.hungerBeforeChartData = {
                        labels: labels.map((label, index) => hungersBefore[index]? label: ' '),
                        series: hungersBefore,
                      };
      this.hungerAfterChartData = {
                        labels: labels.map((label, index) => hungersAfter[index]? label: ' '),
                        series: hungersAfter,
                      };
    },
  },

};
</script>
<style>
.chart-container {
  width: 300px !important;
  height: 300px;
  display: flex;
  flex-direction: column;
}

.chartcolumn {
    display: flex;
    flex-direction: column;
    align-items: center;
  
}
</style>

